// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"dd9e1f47","231":"dd9e1f47","256":"dd9e1f47"}[chunkId] + ".chunk.css";
};